<template>
  <div class="page page-add">
    <div class="page-container">
      <transition name="slide-fade" mode="out-in">
        <template v-if="currentStep == 0">
          <div>
            <div class="page-title">编辑资金池</div>
            <div class="v-px-md v-mt-lg">
              <a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <div class="panel">
                  <div class="panel-body">
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="poolName">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            资金池名称
                          </span>
                          <a-input placeholder="资金池名称" allowClear v-model="form.poolName" ref="poolName" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="usage">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            资金使用方向
                          </span>
                          <a-select v-model="form.usage" placeholder="请选择">
                            <a-select-option value="合作项目-公募合作">合作项目-公募合作</a-select-option>
                            <a-select-option value="合作项目-专项基金">合作项目-专项基金</a-select-option>
                            <a-select-option value="公益人才">公益人才</a-select-option>
                            <a-select-option value="精灵书屋">精灵书屋</a-select-option>
                            <a-select-option value="螺蛳壳改造">螺蛳壳改造</a-select-option>
                            <a-select-option value="爱心100">爱心100</a-select-option>
                            <a-select-option value="其他">其他</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="rsState" label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <a-textarea v-model="form.remark" placeholder="备注" :rows="4" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="rsState" label="公益筹款项目" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <a-transfer :titles="['待选公益筹款项目', '已选公益筹款项目']" :show-select-all="false" :target-keys="targetKeys" :selected-keys="transferSelectedKeys" :render="item => item.title" @change="transferChange">
                            <template slot="children" slot-scope="{ props: { direction }, on: {} }">
                              <div>
                                <a-tabs type="card" v-if="direction == 'left'">
                                  <a-input slot="tabBarExtraContent" v-model="tabSearchVal" placeholder="输入关键字过滤" style="width: 130px" allow-clear />
                                  <a-tab-pane key="1">
                                    <span slot="tab" style="color: #1e6fff">
                                      <!-- <a-icon type="alipay-circle" /> -->
                                      支付宝
                                    </span>
                                    <a-table :columns="columns" :data-source="alipaySourceItemsShow" :row-selection="getAlipayRowSelection()" size="small"></a-table>
                                  </a-tab-pane>
                                  <a-tab-pane key="2">
                                    <span slot="tab" style="color: #7bb32e">
                                      <!-- <a-icon type="wechat" /> -->
                                      微信
                                    </span>
                                    <a-table :columns="columns" :data-source="wechatSourceItemsShow" :row-selection="getWechatRowSelection()" size="small"></a-table>
                                  </a-tab-pane>
                                  <a-tab-pane key="3">
                                    <span slot="tab">
                                      <!-- <a-icon type="money-collect" /> -->
                                      银行转账捐赠
                                    </span>
                                    <a-table :columns="columns" :data-source="largeSourceItemsShow" :row-selection="getWechatRowSelection()" size="small"></a-table>
                                  </a-tab-pane>
                                  <!-- <a-tab-pane key="3" tab="Tab 3">Content of Tab Pane 3</a-tab-pane> -->
                                </a-tabs>
                                <a-table v-if="direction == 'right'" :columns="columns" :data-source="rightData" :row-selection="getRightRowSelection()" size="small"></a-table>
                              </div>
                            </template>
                          </a-transfer>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </a-form-model>

              <a-affix :offset-bottom="10" :target="() => this.$refs.container">
                <!-- <a-divider class="bg-gray"></a-divider> -->
                <div class="text-center">
                  <a-space>
                    <a-button icon="check" type="primary" :loading="saving" @click="handleSubmit">提交</a-button>
                    <a-button icon="undo" type="danger" @click="handleReset">重置</a-button>
                    <a-button icon="rollback" @click="$router.go(-1)">返回</a-button>
                  </a-space>
                </div>
              </a-affix>
            </div>
          </div>
        </template>
        <template v-else-if="currentStep == 1">
          <a-result status="success" title="资金池添加成功">
            <template #extra>
              <a-button key="back" @click="$router.push('list')">返回列表</a-button>
            </template>
          </a-result>
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
import { updatePool, listFundNames, allFundLarge, poolDetail } from '@/api/capital'

const form = {
  poolName: '',
  usage: '',
  remark: '',
}
export default {
  data() {
    return {
      id: this.$route.query.id,
      columns: [
        { title: '项目名称', dataIndex: 'title', ellipsis: true },
        {
          title: '支付方式',
          dataIndex: 'type',
          width: 100,
          align: 'center',
          customRender: text => {
            return this.getPayAlias(text)
          },
        },
      ],
      tabSearchVal: '',
      alipaySourceItems: [],
      wechatSourceItems: [],
      largeSourceItems: [],

      alipaySourceItemsShow: [],
      wechatSourceItemsShow: [],
      largeSourceItemsShow: [],

      rightData: [],

      transferSelectedKeys: [],
      targetKeys: [],

      alipaySelectedKeys: [],
      wechatSelectedKeys: [],
      rightSelectedKeys: [],

      currentStep: 0,
      form: { ...form },
      saving: false,
    }
  },
  watch: {
    tabSearchVal(v) {
      this.filterTabs(v)
    },
  },
  methods: {
    loadFundNames() {
      listFundNames().then(res => {
        let records = res.data.result
        let alipaySourceItems = []
        let wechatSourceItems = []
        for (let rec of records) {
          let item = { key: rec.id + '#' + rec.fundType, title: rec.fundName, type: rec.fundType }
          if (rec.fundType == 0) {
            alipaySourceItems.push(item)
          } else if (rec.fundType == 1) {
            wechatSourceItems.push(item)
          }
        }
        this.alipaySourceItems = alipaySourceItems
        this.wechatSourceItems = wechatSourceItems

        allFundLarge().then(res => {
          let records = res.data.result
          let largeSourceItems = []
          for (let rec of records) {
            let item = { key: rec.id + '#3', title: rec.paymentName, type: 3 }
            largeSourceItems.push(item)
          }
          this.largeSourceItems = largeSourceItems

          poolDetail({ id: this.id }).then(({ data }) => {
            if (data.success) {
              this.form = { ...data.result }
              let fundNames = data.result.fundNames
              let moveKeys = []
              if (fundNames) {
                for (let fundName of fundNames) {
                  // moveKeys += fundName.id + '#' + fundName.fundType + ','
                  moveKeys.push(fundName.id + '#' + fundName.fundType)
                }
              }
              let fundLarges = data.result.fundLarges
              if (fundLarges && fundLarges.length > 0) {
                // moveKeys += fundLarge.id + '#3'
                for (let fundLarge of fundLarges) {
                  moveKeys.push(fundLarge.id + '#3')
                }
              }
              this.leftToRight(moveKeys)
            }
          })
        })
      })
    },
    initTransfer() {
      listFundNames().then(res => {
        let records = res.data.result
        let alipaySourceItems = []
        let wechatSourceItems = []
        for (let rec of records) {
          let item = { key: rec.id + '#' + rec.fundType, title: rec.fundName, type: rec.fundType }
          if (rec.fundType == 0) {
            alipaySourceItems.push(item)
          } else if (rec.fundType == 1) {
            wechatSourceItems.push(item)
          }
        }
        this.alipaySourceItems = alipaySourceItems
        this.wechatSourceItems = wechatSourceItems

        allFundLarge().then(res => {
          let records = res.data.result
          let largeSourceItems = []
          for (let rec of records) {
            let item = { key: rec.id + '#3', title: rec.paymentName, type: 3 }
            largeSourceItems.push(item)
          }
          this.largeSourceItems = largeSourceItems
        })
      })
    },
    filterTabs(keyword) {
      this.alipaySourceItemsShow = this.alipaySourceItems.filter(({ title }) => {
        return title.indexOf(keyword) != -1
      })
      this.wechatSourceItemsShow = this.wechatSourceItems.filter(({ title }) => {
        return title.indexOf(keyword) != -1
      })
      this.largeSourceItemsShow = this.largeSourceItems.filter(({ title }) => {
        if (title) {
          return title.indexOf(keyword) != -1
        }
        return false
      })
    },
    getAlipayRowSelection() {
      return {
        selectedRowKeys: this.alipaySelectedKeys,
        onChange: selectedRowKeys => {
          this.alipaySelectedKeys = selectedRowKeys
          this.rightSelectedKeys = []
          this.transferSelectedKeys = this.alipaySelectedKeys.concat(this.wechatSelectedKeys)
        },
      }
    },
    getWechatRowSelection() {
      return {
        selectedRowKeys: this.wechatSelectedKeys,
        onChange: selectedRowKeys => {
          this.wechatSelectedKeys = selectedRowKeys
          this.rightSelectedKeys = []
          this.transferSelectedKeys = this.alipaySelectedKeys.concat(this.wechatSelectedKeys)
        },
      }
    },
    getRightRowSelection() {
      return {
        selectedRowKeys: this.rightSelectedKeys,
        onChange: selectedRowKeys => {
          this.rightSelectedKeys = selectedRowKeys
          this.alipaySelectedKeys = []
          this.wechatSelectedKeys = []
          this.transferSelectedKeys = selectedRowKeys
          this.targetKeys = selectedRowKeys
        },
      }
    },
    transferChange(targetKeys, direction, moveKeys) {
      if (direction == 'right') {
        this.leftToRight(moveKeys)
      } else if (direction == 'left') {
        this.rightToLeft(moveKeys)
      }
      this.alipaySelectedKeys = []
      this.rightSelectedKeys = []
      this.transferSelectedKeys = []
    },
    leftToRight(moveKeys) {
      // let moveKeyArr = []
      // for (let moveKey of moveKeys.split(',')) {
      //   if (moveKey) {
      //     moveKeyArr.push(moveKey)
      //   }
      // }
      let alipayNewArr = []
      for (let data of this.alipaySourceItems) {
        if (moveKeys.indexOf(data.key) != -1) {
          this.rightData.push(data)
        } else {
          alipayNewArr.push(data)
        }
      }
      this.alipaySourceItems = alipayNewArr

      let wechatNewArr = []
      for (let data of this.wechatSourceItems) {
        if (moveKeys.indexOf(data.key) != -1) {
          this.rightData.push(data)
        } else {
          wechatNewArr.push(data)
        }
      }
      this.wechatSourceItems = wechatNewArr

      let largeNewArr = []
      for (let data of this.largeSourceItems) {
        if (moveKeys.indexOf(data.key) != -1) {
          this.rightData.push(data)
        } else {
          largeNewArr.push(data)
        }
      }
      this.largeSourceItems = largeNewArr

      this.targetKeys = []

      this.filterTabs(this.tabSearchVal)
    },
    rightToLeft(moveKeys) {
      let rightNewArr = []
      let rightNewKeyArr = []
      for (let data of this.rightData) {
        if (moveKeys.indexOf(data.key) != -1) {
          if (data.type == 0) this.alipaySourceItems.push(data)
          if (data.type == 1) this.wechatSourceItems.push(data)
          if (data.type == 3) this.largeSourceItems.push(data)
        } else {
          rightNewArr.push(data)
          rightNewKeyArr.push(data.key)
        }
      }
      this.rightData = rightNewArr
      this.targetKeys = rightNewKeyArr
    },
    transferRest() {},
    getPayAlias(type) {
      if (type == 0)
        return (
          <span style="color: #1e6fff">
            <a-icon type="alipay-circle" />
            &nbsp;支付宝
          </span>
        )
      if (type == 1)
        return (
          <span style="color: #7bb32e">
            <a-icon type="alipay-circle" />
            &nbsp;微信
          </span>
        )
      return ''
    },
    handleSubmit() {
      let { poolName, usage, remark } = this.form
      this.$message.destroy()
      if (poolName.trim() === '') {
        this.$message.warning('请输入资金池名称')
        this.$refs.poolName.focus()
        return
      }
      if (usage.trim() === '') {
        this.$message.warning('请选择资金使用方向')
        this.$refs.usage.focus()
        return
      }
      if (this.rightData.length == 0) {
        this.$message.warning('请选择公益筹款项目')
        return
      }
      let params = {
        id: this.id,
        poolName,
        usage,
        remark,
      }
      params.fundNameIds = this.rightData
        .map(function (elem) {
          return elem.key
        })
        .join(',')
      this.saving = true
      updatePool(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.id = data.result
            this.currentStep = 1
          } else {
            this.$message.error('操作失败')
          }
          this.saving = false
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    handleReset() {
      this.selectedRowKeys = []
      this.form = { ...form }
      this.alipaySourceItems = []
      this.wechatSourceItems = []
      this.largeSourceItems = []
      this.rightData = []
      this.transferSelectedKeys = []
      this.targetKeys = []
      this.alipaySelectedKeys = []
      this.wechatSelectedKeys = []
      this.rightSelectedKeys = []
      this.initTransfer()
    },
  },
  mounted() {
    this.loadFundNames()
  },
}
</script>

<style scoped>
.ant-transfer-list {
  width: 500px !important;
  height: 580px !important;
}
.ant-tag-green {
  color: #55a027;
  background: #f6ffed;
  border-color: #55a027;
}
.ant-tag-blue {
  color: #1777ff;
  background: #e6f7ff;
  border-color: #1777ff;
}
</style>
